/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import IconButton from '@mui/material/IconButton';
import Icon from "@mui/material/Icon";
import DataTable from "examples/Tables/DataTable";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDButton from "components/MDButton";
import CustomAlert from "components/CustomAlert";

// Data
import { useEffect, useState, useMemo } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { useMaterialUIController, setLoading } from "context";
import ConfirmDialog from "components/ConfirmDialog";
import TableSkeleton from "components/TableSkeleton";
import { MachineAPI } from "api/MachineAPI";
import permissions from "permissions";


export default function ListMachine() {
  const [alert, setAlert] = useState(false);
  const [alertContent, setAlertContent] = useState('');
  const [alertColor, setAlertColor] = useState('info');
  const [controller, dispatch] = useMaterialUIController();
  const [id, setId] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [machines, setMachines] = useState([]);
  const { user, loading, admin } = controller;
  const navigate = useNavigate();
  const location = useLocation();
  const message = location.state;

  const handleAlert = (content, color) => {
    setAlertContent(content);
    setAlertColor(color);
    setAlert(true)
  }

  const handleAlertClose = () => setAlert(false);

  const handleClick = () => {
    navigate('create');
  }

  const handleDelete = (id) => {
    setId(id)
    setIsDeleting(true);
  }

  const handleCancelDelete = () => {
    setIsDeleting(false);
  };

  const handleConfirmDelete = () => {
    return deleteMachine(id)
  };

  const renderTable = useMemo(() => {
    let rows = [];
    const columns = [
      { Header: "Código", accessor: "codigo", align: "left" },
      { Header: "Planta", accessor: "id_planta", align: "left" },
      { Header: "Serie", accessor: "serie", align: "left" },
      { Header: "Fabricante", accessor: "fabricante", align: "left" },
      { Header: "acción", accessor: "action", align: "center" },
    ];

    machines.map((element) => {
      rows = [...rows,
      {
        codigo: element.codigo,
        id_planta: element.plants.nombre,
        serie: element.serie,
        fabricante: element.fabricante,
        action: (
          <MDBox>
            {(user?.permissions?.includes(permissions.machines[2]) || user?.role === admin) && (
              <IconButton component={Link} aria-label="edit" value={element.id} to={element.id + '/edit'}>
                <Icon fontSize="small">edit</Icon>
              </IconButton>
            )}
            {(user?.permissions?.includes(permissions.machines[3]) || user?.role === admin) && (
              <IconButton aria-label="delete" value={element.id} onClick={() => handleDelete(element.id)}>
                <Icon fontSize="small">delete</Icon>
              </IconButton>
            )}
          </MDBox>
        ),
      }
      ]
    });

    return <DataTable
      table={{ columns, rows }}
      isSorted={true}
      entriesPerPage={true}
      showTotalEntries={true}
      noEndBorder
      canSearch={true}
    />

  }, [machines]);

  const getMachines = (signal) => {
    return MachineAPI.index(signal)
      .then(response => {
        setMachines(response.machines)
      }).catch(error => {
        if (error.response) {
          handleAlert(error.response.data.message, 'error')
        }
      }).finally(() => {
        setLoading(dispatch, false)
      });
  }

  const deleteMachine = (id) => {
    return MachineAPI.delete(id)
      .then(response => {
        const updatedMachines = machines.filter((machine) => machine.id !== response.machine);
        setMachines(updatedMachines);
        handleAlert(response.message, 'success');
      }).catch(error => {
        if (error.response) {
          handleAlert(error.response.data.message, 'error')
        }
      }).finally(() => {
        handleCancelDelete();
      });

  }

  useEffect(() => {
    if (message) {
      handleAlert(message, 'success');
    }
  }, [message]);


  useEffect(() => {

    window.history.replaceState({}, document.title)
    const abortController = new AbortController();
    const signal = abortController.signal

    setLoading(dispatch, true)
    getMachines(signal);

    return () => {
      abortController.abort();
    };
  }, []);


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12} lg={12}>
            <MDBox mb={4} px={2}>
              <CustomAlert severity={alertColor} message={alertContent} open={alert} onClose={handleAlertClose}></CustomAlert>
            </MDBox>
            <MDBox sx={{ display: 'flex', flexDirection: 'row-reverse', pb: 3 }}>
              {(user?.permissions?.includes(permissions.machines[1]) || user?.role === admin) && (
                <MDButton variant="gradient" color="info" onClick={handleClick}>Crear</MDButton>
              )}
            </MDBox>
            <Card>
              <MDBox>
                {loading ? <TableSkeleton></TableSkeleton> :
                  <MDBox pt={3}>
                    {renderTable}
                  </MDBox>}
              </MDBox>
            </Card>
            {isDeleting && (<ConfirmDialog onConfirm={handleConfirmDelete} onCancel={handleCancelDelete} ></ConfirmDialog>)}
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}










